export const DATE_FORMAT_DB = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIMEZONE = 'Asia/Jakarta';